import { useState } from 'react'
import { GsaFilters } from './GsaMasCatalog.types'

const EMPTY_FILTERS: GsaFilters = {
  awardModNo: '',
  vendorName: '',
  manufacturerName: '',
  mfrPartNo: '',
  productDescription: '',
  contractOfferNo: '',
  vendorPartNo: '',
  uei: '',
  baseOrAccessory: '',
  productName: '',
}

export function useGsaMasCatalogFilters() {
  const [filters, setFilters] = useState<GsaFilters>(EMPTY_FILTERS)
  const [committedFilters, setCommittedFilters] = useState<GsaFilters>(EMPTY_FILTERS)
  const [advancedOpen, setAdvancedOpen] = useState(false)

  function setFilter<K extends keyof GsaFilters>(key: K, value: GsaFilters[K]) {
    setFilters(prev => ({ ...prev, [key]: value }))
  }

  function search() {
    setCommittedFilters(filters)
  }

  function clearFilters() {
    setFilters(EMPTY_FILTERS)
    setCommittedFilters(EMPTY_FILTERS)
  }

  return { filters, setFilter, clearFilters, search, committedFilters, advancedOpen, setAdvancedOpen }
}
